import localization from "../../statics/localization";
import { flowCopy } from "../../utils/flowCopy";

export function loginErrorMessage(error) {
  if (error?.code === "MW_API_KEY_MISSING") {
    const tr = localization.getLanguage() === "tr";
    if (process.env.NODE_ENV === "development") {
      return localization.getLanguage() === "arb" ? "خدمة تسجيل الدخول غير مهيأة. يرجى الاتصال بالدعم." : tr
        ? "Giriş ayarı eksik: .env.local içindeki REACT_APP_MW_API_KEY değerini kontrol edip geliştirme sunucusunu yeniden başlatın."
        : "Login configuration is missing. Check REACT_APP_MW_API_KEY in .env.local and restart the development server.";
    }
    return localization.getLanguage() === "arb" ? "خدمة تسجيل الدخول غير مهيأة. يرجى الاتصال بالدعم." : tr
      ? "Giriş hizmeti henüz yapılandırılmamış. Lütfen destek ekibiyle iletişime geçin."
      : "The sign-in service has not been configured. Please contact support.";
  }
  // MW reports invalid credentials as an HTTP-200 business error.
  if (Number(error?.code) === 6010 || error?.response?.status === 401) {
    return localization.userInfoIncorrect;
  }
  return flowCopy().error;
}
